export const querykeys = {
  loggedUser: "logged-user",
  apiSecrets: (profileId: number) => ["api-secrets", profileId],
  registerRequest: (token: string) => [`register-request`, token],
  hostedFieldToken: () => [`hosted-field-token`],
  plans: "plans",
  osm: "osm",
  serviceAvailability: "service-availability",
  lastPaymentMethod: "last-payment-method",
};
